import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { List } from 'immutable';
import UMOCarouselView from './UMOCarouselView';
import UMOCarouselReel from './UMOCarouselReel';

const mapStateToProps = state => ({
  session: state.session,
});

const mapDispatchToProps = dispatch => ({
  dispatch: actionToDispatch => dispatch(actionToDispatch),
});

// todo: refactor. remove isNotJustified, use classNameModifier -- i.e. same as workspace preview
function UMOCarousel({
  umoList,
}) {
  return (
    <div className="umo-gallery__carousel">
      <div className="umo-gallery__carousel__view">
        <UMOCarouselView umoList={umoList} />
      </div>
      <div className="umo-gallery__carousel__rail">
        <UMOCarouselReel umoList={umoList} />
      </div>
    </div>
  );
}

UMOCarousel.propTypes = {
  umoList: PropTypes.instanceOf(List).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(UMOCarousel);
